"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var hikakaku_san_png_1 = __importDefault(require("images/line_consultation_modal/hikakaku-san.png"));
var LineConsultationModal = /** @class */ (function (_super) {
    __extends(LineConsultationModal, _super);
    function LineConsultationModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.open = true;
        _this.handleClose = function () {
            _this.open = false;
        };
        return _this;
    }
    LineConsultationModal.prototype.render = function () {
        var lineBotId = this.props.lineBotId;
        return (react_1.default.createElement(react_responsive_modal_1.default, { onClose: this.handleClose, open: this.open, classNames: { modal: "lineConsultationModal-Modal" } },
            react_1.default.createElement("a", { className: "lineConsultationModal-Modal_Container", href: "line://oaMessage/@".concat(lineBotId, "/?\u67FB\u5B9A\u7533\u8FBC") },
                react_1.default.createElement("img", { className: "lineConsultationModal-Modal_TitleImage lazyload", src: hikakaku_san_png_1.default, alt: "LINE\u3067\u67FB\u5B9A\u3059\u308B" }),
                react_1.default.createElement("div", { className: "lineConsultationModal-Modal_Button" }, "LINE\u3067\u67FB\u5B9A\u3059\u308B\u969B\u306F\u3053\u3061\u3089\u3092\u30AF\u30EA\u30C3\u30AF"),
                react_1.default.createElement("div", { className: "lineConsultationModal-Modal_Description" },
                    "LINE\u30A2\u30D7\u30EA\u304C\u3053\u3061\u3089\u306EPC\u307E\u305F\u306F\u643A\u5E2F\u7AEF\u672B\u306B\u306A\u3044\u5834\u5408\u3001",
                    react_1.default.createElement("br", null),
                    "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3082\u30A2\u30D7\u30EA\u304C\u8D77\u52D5\u3055\u308C\u307E\u305B\u3093\u3002",
                    react_1.default.createElement("br", null),
                    "\u4E88\u3081LINE\u30A2\u30D7\u30EA\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3092\u304A\u9858\u3044\u81F4\u3057\u307E\u3059\u3002"))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], LineConsultationModal.prototype, "open", void 0);
    LineConsultationModal = __decorate([
        mobx_react_1.observer
    ], LineConsultationModal);
    return LineConsultationModal;
}(react_1.default.Component));
exports.default = LineConsultationModal;
